import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import OfferCarouselUI from '../../../../stories/components/hotels/HomePage/OfferCarouselUI/OfferCarouselUI';
import {offersApiSelectorFn} from '../redux/selectors';
// import {prepareBrandPromisesApiRequest} from '../utils/prepareBrandPromisesApiRequest';
// import {xhrHelper} from '../../../utils/xhrHelper';
import OfferCarouselLoader from '../../../../stories/components/hotels/HomePage/OfferCarouselLoader/OfferCarouselLoader';
import {pushga} from 'ga-utils';
import {HomePageGAEvents} from '../../../config/ga-config';
import {eventMiddlewareForHotelsDwebFE} from '../../../utils/common-utils';
import {
  homeBannerDataSelector,
  smartEngageLoadingStatusSelector,
} from '@stencil/hotels-smartengage-store/src/selectors';
const OfferCarousel = ({offersDataFromState = []}) => {
  // const [isLoading, setIsLoading] = useState(true);
  // const [data, setData] = useState([]);
  // const {data: offersDataFromState, isLoading: isOffersCarouselLoading} = useSelector(
  //   offersApiSelectorFn,
  // );

  const homeBannersSmartEngage = useSelector(homeBannerDataSelector);
  const smartEngageLoading = useSelector(smartEngageLoadingStatusSelector);
  // useEffect(() => {
  //   xhrHelper({
  //     name: 'brand promises api',
  //     type: 'GET',
  //     url: prepareBrandPromisesApiRequest(),
  //   })
  //     .then(response => {
  //       // move to store
  //       setData(
  //         response.data.success
  //           ? response.data.data?.new_dweb_homepage_banner?.template?.banner
  //           : [],
  //       );
  //       setIsLoading(false);
  //     })
  //     .catch(err => {
  //       setIsLoading(false);
  //       console.error(err);
  //     });
  // }, []);

  const actionHandler = item => {
    window.open(item);
  };

  // ! need to stitch loader for OffeCarousel
  if (!offersDataFromState.length || smartEngageLoading) return <OfferCarouselLoader />;
  // if (!isOffersCarouselLoading && (!offersDataFromState || offersDataFromState.length === 0))
  //   return null;

  const homePageClicksGAHandler = (type: 'todaysOfferClicked' | 'bannerClicked', val) => {
    switch (type) {
      case 'todaysOfferClicked':
        pushga({
          eventCategory: HomePageGAEvents.hotelHomePageClicks.category,
          eventAction: HomePageGAEvents.hotelHomePageClicks.action.todaysOfferClicked,
        });
        break;
      case 'bannerClicked':
        pushga({
          eventCategory: HomePageGAEvents.hotelHomePageClicks.category,
          eventAction: HomePageGAEvents.hotelHomePageClicks.action.todaysOfferClicked,
          eventLabel: val,
        });
        break;

      default:
        break;
    }
  };

  const sliderClicksGAHandler = index => {
    pushga({
      eventCategory: HomePageGAEvents.sliderClicks.category,
      eventAction: HomePageGAEvents.sliderClicks.action.offerSliderClicked,
      eventLabel: index,
    });
  };

  return (
    <OfferCarouselUI
      bannerData={homeBannersSmartEngage}
      dataFromState={offersDataFromState}
      actionHandler={actionHandler}
      eventMiddlewareForHotelsDwebFE={eventMiddlewareForHotelsDwebFE}
      homePageClicksGAHandler={homePageClicksGAHandler}
      sliderClicksGAHandler={sliderClicksGAHandler}
    />
  );
};

export default OfferCarousel;
